/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FileDetails {
    getFixupPrototypeFunction() { return FileDetails.fixupPrototype; }

    static newInstance(model: Partial<FileDetails>): FileDetails {
        let obj = Object.assign(new FileDetails(), model);
        FileDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FileDetails>): FileDetails {
        if (!model) return null;
        return FileDetails.newInstance(<FileDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FileDetails) {
        if (!obj) return;

        models.FileDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FileDetails): boolean {
        Object.setPrototypeOf(obj, FileDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.file_size === undefined) {
            this.file_size = 0;
        }
        if (this.multipart_metadata) {
            models.MultipartUploadMetadata.fixupPrototype(this.multipart_metadata);
        }
    }

    /**
     * Name of the file
     */
    file_name: string;

    /**
     * Size of the file
     */
    file_size: number;

    /**
     * Multi part upload metadata details
     */
    multipart_metadata: models.MultipartUploadMetadata;

}
